import { useRef, useState } from "react";
import { createPortal } from "react-dom";

type Props = {
  /** 吹き出しに出す説明 */
  text: string;
};

const TIP_WIDTH = 192; // w-48
const MARGIN = 8;

/** 「?」に重ねると説明を出す。表の囲み（overflow-hidden）に切られないよう、
 * body の直下に描き、画面に対して「?」のすぐ下に置く（右端・左端では画面の内側に寄せる）。 */
function HelpTip({ text }: Props) {
  const ref = useRef<HTMLSpanElement>(null);
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);

  const show = () => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const center = rect.left + rect.width / 2;
    const left = Math.min(
      Math.max(center - TIP_WIDTH / 2, MARGIN),
      window.innerWidth - TIP_WIDTH - MARGIN,
    );
    setPos({ top: rect.bottom + MARGIN, left });
  };
  const hide = () => setPos(null);

  return (
    <span
      ref={ref}
      tabIndex={0}
      aria-label={text}
      className="ml-1 inline-block w-4 h-4 rounded-full bg-gray-200 text-gray-600 text-xs cursor-help"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      ?
      {pos &&
        createPortal(
          <span
            role="tooltip"
            style={{ top: pos.top, left: pos.left, width: TIP_WIDTH }}
            className="fixed p-2 bg-gray-800 text-white text-xs font-normal rounded pointer-events-none text-left z-50 whitespace-normal"
          >
            {text}
          </span>,
          document.body,
        )}
    </span>
  );
}

export default HelpTip;
